// assets
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - CALENDAR ||============================== //

const calendar: NavItemType = {
    id: 'calendar',
    title: 'Calendar',
    icon: CalendarMonthIcon,
    type: 'group',
    url: ERoutes.calendar,
    children: [
        {
            id: 'calendar',
            title: 'Calendar',
            type: 'item',
            icon: CalendarMonthIcon,
            url: ERoutes.calendar,
            breadcrumbs: false
        },
        {
            id: 'crm-tasks',
            title: 'Tasks',
            type: 'item',
            icon: TaskAltIcon,
            url: ERoutes.crmTasks,
            breadcrumbs: false
        },
        {
            id: 'crm-meetings',
            title: 'Meetings',
            type: 'item',
            icon: EventAvailableIcon,
            url: ERoutes.crmMeetings,
            breadcrumbs: false
        }
    ]
};

export default calendar;
